import { Type } from 'main.core';

export class GaTargets {
	constructor(options = { name: 'GaTargets' }) {
		this.name = options.name;
	}

	registrationEvent() {
		try {
			dataLayer.push({
				'event': 'GAEvent',
				'eventCategory': 'form',
				'eventAction': 'success',
				'eventLabel': 'registration'
			});
		} catch (error) {
			console.error({ error })
		}
	}

	authEvent() {
		try {
			dataLayer.push({
				'event': 'GAEvent',
				'eventCategory': 'form',
				'eventAction': 'success',
				'eventLabel': 'auth'
			});
		} catch (error) {
			console.error({ error })
		}
	}

	subscribeEvent(sWay) {
		if (!sWay)
			return;

		try {
			dataLayer.push({
				'event': 'GAEvent',
				'eventCategory': 'form',
				'eventAction': 'success',
				'eventLabel': sWay
			});
		} catch (error) {
			console.error({ error })
		}
	}

	clickEvent(sType) {
		if (!sType)
			return;

		try {
			dataLayer.push({
				'event': 'GAEvent',
				'eventCategory': 'click',
				'eventAction': 'success',
				'eventLabel': sType
			});
		} catch (error) {
			console.error({ error })
		}
	}

	setName(name) {
		if (Type.isString(name)) {
			this.name = name;
		}
	}

	getName() {
		return this.name;
	}
}